import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { ContentHeader, ContentBody } from 'areas/shared/components';
import ModalsDemo from './ModalsDemo';
import NotificationsDemo from './NotificationsDemo';

const Modals = () => (
	<React.Fragment>
		<ContentHeader title="Modals" description="Different forms of modals">
		</ContentHeader>
		<ContentBody>
			<Row>
				<Col md={6}>
					<ModalsDemo />
				</Col>
				<Col md={6}>
					<NotificationsDemo />
				</Col>
			</Row>
		</ContentBody>
	</React.Fragment>
)

export default Modals;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Modals/index.js